import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DiaDaGrade, EstadoOnboardingPainel, OnboardingPainelService} from '../onboarding-painel.service';
import {OnbFocoService} from '../apoio/onb-foco.service';

const DIAS = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
/** Ordem de leitura do dono: a semana começa na segunda. */
const ORDEM = [1, 2, 3, 4, 5, 6, 0];

/**
 * Passo 3 · Horários. Grade da semana com atalhos; fechar depois da meia-noite vira madrugada sem o dono pensar.
 * A frase ao vivo mostra como a loja aparece agora, e lembra que o pedido de teste passa mesmo fechada.
 */
@Component({
  selector: 'app-passo-horarios',
  templateUrl: './passo-horarios.component.html',
  styleUrls: ['./passo-horarios.component.scss']
})
export class PassoHorariosComponent implements OnInit {
  @Input() estado: EstadoOnboardingPainel;
  @Output() concluido = new EventEmitter<EstadoOnboardingPainel>();

  grade: DiaDaGrade[] = [];
  salvando = false;
  erro = '';
  readonly ordem = ORDEM;

  constructor(private onboarding: OnboardingPainelService, private foco: OnbFocoService) {}

  ngOnInit(): void {
    const atual = this.estado?.grade;
    const configurada = atual && atual.some(d => d.aberto);
    this.grade = configurada ? atual.map(d => ({...d}))
      : [0, 1, 2, 3, 4, 5, 6].map(dia => ({dia, aberto: dia !== 1, abre: '18:00', fecha: '23:00'}));
  }

  nome(dia: number): string { return DIAS[dia]; }

  dia(dia: number): DiaDaGrade { return this.grade.find(d => d.dia === dia); }

  viraMadrugada(d: DiaDaGrade): boolean { return d.aberto && !!d.abre && !!d.fecha && d.fecha < d.abre; }

  diaSeguinte(dia: number): string { return DIAS[(dia + 1) % 7].toLowerCase(); }

  atalho(tipo: 'noite' | 'almoco' | 'copiar' | 'segunda'): void {
    if (tipo === 'noite') this.grade.forEach(d => Object.assign(d, {aberto: true, abre: '18:00', fecha: '23:00'}));
    if (tipo === 'almoco') this.grade.forEach(d => Object.assign(d, {aberto: d.dia !== 0, abre: '11:00', fecha: '15:00'}));
    if (tipo === 'copiar') {
      const sexta = this.dia(5);
      this.grade.forEach(d => Object.assign(d, {aberto: sexta.aberto, abre: sexta.abre, fecha: sexta.fecha}));
    }
    if (tipo === 'segunda') this.dia(1).aberto = false;
  }

  private minutos(hora: string): number {
    const [h, m] = String(hora || '0:0').split(':').map(Number);
    return h * 60 + m;
  }

  /** "Aberta até 23:00", "Fechada · abre hoje às 18:00"... com o relógio deste aparelho. */
  get statusAgora(): {texto: string; aberta: boolean} {
    const agora = new Date(), hoje = agora.getDay(), min = agora.getHours() * 60 + agora.getMinutes();
    const ontem = this.dia((hoje + 6) % 7), dHoje = this.dia(hoje);
    if (ontem?.aberto && this.viraMadrugada(ontem) && min < this.minutos(ontem.fecha)) return {texto: `aberta até ${ontem.fecha}`, aberta: true};
    if (dHoje?.aberto) {
      const abre = this.minutos(dHoje.abre), fecha = this.minutos(dHoje.fecha);
      if (min >= abre && (this.viraMadrugada(dHoje) || min < fecha)) return {texto: `aberta até ${dHoje.fecha}`, aberta: true};
      if (min < abre) return {texto: `fechada · abre hoje às ${dHoje.abre}`, aberta: false};
    }
    for (let k = 1; k <= 7; k++) {
      const d = this.dia((hoje + k) % 7);
      if (d?.aberto) return {texto: `fechada · abre ${k === 1 ? 'amanhã' : DIAS[d.dia].toLowerCase()} às ${d.abre}`, aberta: false};
    }
    return {texto: 'fechada todos os dias', aberta: false};
  }

  salve(): void {
    if (this.salvando) return;
    if (!this.grade.some(d => d.aberto)) return this.foco.mostre('onb-semana', 'Ligue pelo menos um dia da semana e diga o horário.');
    const errado = ORDEM.map(n => this.dia(n)).find(d => d.aberto && (!d.abre || !d.fecha || d.abre === d.fecha));
    if (errado) return this.foco.mostre('onb-dia-linha-' + errado.dia, `Confira ${DIAS[errado.dia].toLowerCase()}: a loja precisa abrir e fechar em horários diferentes.`);
    this.salvando = true;
    this.erro = '';
    this.onboarding.salveHorarios(this.grade).then(estado => this.concluido.emit(estado))
      .catch(e => this.erro = OnboardingPainelService.mensagem(e))
      .finally(() => this.salvando = false);
  }
}
